import { Clock } from "lucide-react";
import React from "react";

interface HeatMapLegendProps {
  className?: string;
}

export const HeatMapLegend: React.FC<HeatMapLegendProps> = ({
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col gap-1.5 w-full ${className}`}
      role="img"
      aria-label="Heat map color legend showing time until event - blue for far away, yellow-orange for soon, red for imminent"
    >
      {/* Label */}
      <div className="flex items-center gap-1.5 text-white">
        <Clock className="h-4 w-4 opacity-90" aria-hidden="true" />
        <span className="text-sm sm:text-base font-medium opacity-90">
          Time Until Event
        </span>
      </div>

      {/* Gradient Bar with Labels */}
      <div className="flex items-center gap-2 sm:gap-3 w-full">
        <span
          className="text-xs sm:text-sm text-white opacity-75 whitespace-nowrap font-medium"
          aria-label="Far away events shown in blue"
        >
          Far Away
        </span>
        <div
          className="flex-1 h-4 rounded-full border-2 border-white/40 shadow-md"
          style={{
            background:
              "linear-gradient(to right, #0ea5e9, #06b6d4, #14b8a6, #84cc16, #eab308, #f97316, #ea580c, #dc2626, #b91c1c, #991b1b)",
          }}
          aria-hidden="true"
        />
        <span
          className="text-xs sm:text-sm text-white opacity-75 whitespace-nowrap font-medium"
          aria-label="Imminent events shown in red"
        >
          Very Soon
        </span>
      </div>
    </div>
  );
};

export default HeatMapLegend;
